module.exports = __webpack_public_path__ + "img/logo-icon.4010de99.png";